import { CommonModule } from "@angular/common";
import { Component, ElementRef, Renderer2 } from "@angular/core";
import { Router } from "@angular/router";
import { SeamlessHeaderComponent } from "../shared/seamless-header.component";

@Component({
    selector: 'app-ready-screen',
    templateUrl: './ready-screen.component.html',
    styleUrls: ['./ready-screen.component.css'],
    standalone: true,
    imports: [CommonModule,SeamlessHeaderComponent]
})
export class ReadyScreenComponent {
    allowNavigation = false;
    username:string='';

    constructor(private router: Router,
                private renderer: Renderer2,
                private el: ElementRef) { }

    ngOnInit() {
    let userDataStr = localStorage.getItem('apiUserModel');
    let userData = userDataStr ? JSON.parse(userDataStr) : null;
    this.username = userData?.given_name;



    setTimeout(() => {
      this.renderer.addClass(this.el.nativeElement, 'fade-out-up');

      setTimeout(() => {
        this.router.navigate(['/portal/dashboard']);
      }, 400); 
    }, 2000); 
  }

  cleanupStorage() {
    localStorage.removeItem('OnLoadCheck');
  }

   allowUserNavigation() {
    this.allowNavigation = true;
  }

}